import { Box, Button, Typography } from '@mui/material'

import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useStyles } from '../styles'
import useTranslations from '../../../i18n/useTranslations'
import FileUploaderContacts from '../../../ui/components/FileUploaderContacts/FileUploaderContacts'
import { useState } from 'react'
import { format } from 'date-fns'

const FileUploadModal = ({
  openModal,
  handleAddFile,
  handleRemoveFile,
  filesToUpload,
  manifestFiles,
}) => {
  const classes = useStyles()
  const t = useTranslations()
  const [isLoading, setIsLoading] = useState(false)
  const acceptedFileTypes = '.xlsx, .csv'

  const openCSV = async () => {
    // NOTE: solución temporal. En el futuro, el PDF será alojado en un servidor
    // o será accesible vía API.
    const file = await fetch(
      process.env.PUBLIC_URL + '/documents/Fichero para grabación masiva.csv',
    )
    const blob = await file.blob()
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'Grabación Masiva Plantilla.csv') // Cambia 'nombre_deseado.csv' al nombre deseado
    link.click()
  }

  const isDisabled = () => {
    return (
      isLoading ||
      filesToUpload?.some(element => 'error' in element) ||
      !filesToUpload?.length
    )
  }

  const onClickImport = async () => {
    await manifestFiles.mutate({
        file: filesToUpload[0],
        initialPickupDetails: {
          has_pickup_asap: false,
          is_fixed_pickup: true,
          comments: 'Usar recogida fija',
          date: format(new Date(), 'yyyy-MM-dd'),
          time: [],
        },
      })
  }

  return (
    <>
      <Box className={classes.column}>
        <Typography className={classes.subtitle}>
          {t('agenda:import-description')}
        </Typography>
        <Box className={classes.modalContent}>
          <Box className={classes.uploaderContent}>
            <FileUploaderContacts
              onAdd={handleAddFile}
              onDelete={handleRemoveFile}
              onLoad={setIsLoading}
              acceptFiles={acceptedFileTypes}
              initialFiles={filesToUpload}
              maxFiles={1}
              height={300}
            />
          </Box>
          <Box className={classes.instructionsContent}>
            <Typography variant={'h2'} className={classes.subtitle}>
              {t('agenda:how-import')}
            </Typography>
            <Typography
              className={clsx(classes.secondaryText, classes.stepText)}
            >
              <span className={classes.pointStep}>{1}</span>
              <span>
                {t('agenda:step-1-1', {
                  csv: (
                    <u style={{ color: 'red', cursor:'pointer' }} onClick={openCSV}>
                      {t('agenda:step-1-2')}
                    </u>
                  ),
                })}
              </span>
            </Typography>
            <Typography
              className={clsx(classes.secondaryText, classes.stepText)}
            >
              <span className={classes.pointStep}>{2}</span>
              {t('agenda:step-2')}
            </Typography>
            <Typography
              className={clsx(classes.secondaryText, classes.stepText)}
            >
              <span className={classes.pointStep}>{3}</span>
              {t('agenda:step-3')}
            </Typography>
          </Box>
        </Box>
        <Box className={classes.buttonsGroup}>
          <Button
            variant="outlined"
            className={classes.cancelButton}
            size={'small'}
            onClick={() => openModal(false)}
          >
            {t('action:cancel')}
          </Button>
          <Button
            size={'small'}
            onClick={() => onClickImport()}
            disabled={isDisabled()}
          >
            {t('action:import-file')}
          </Button>
        </Box>
      </Box>
    </>
  )
}

FileUploadModal.propTypes = {
  openModal: PropTypes.func,
  handleAddFile: PropTypes.func,
  handleRemoveFile: PropTypes.func,
  filesToUpload: PropTypes.array,
  manifestFiles: PropTypes.object
}

export default FileUploadModal
